import React from "react";
import FiledUtilityDashboard from "../../components/filedUtilityService";
import Layout from "../../layout";

const FieldUtilityService: React.FC = () => {
  return (
    <Layout>
      <FiledUtilityDashboard />
    </Layout>
  );
};

export default FieldUtilityService;
